// acneScarsRemovalData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[] | any;
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const ivdrips: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Best IV Drip Therapy at Home Dubai | Elite Body Home",
            "description": "Professional IV drip therapy at home in Dubai with FREE consultation! Get hydration, vitamins and energy-boosting nutrients delivered to your doorstep. Book now.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/iv-drip-therapy-dubai/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Best IV Drip Therapy at Home Dubai | Elite Body Home",
                "description": "Professional IV drip therapy at home in Dubai with FREE consultation! Get hydration, vitamins and energy-boosting nutrients delivered to your doorstep. Book now.",
                "url": "https://elitebodyhome.com/services/iv-drip-therapy-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-22T13:54:57+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-IV-Therapy.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-IV-Therapy.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "IV Drip Therapy Dubai",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Best IV Drip Therapy at Home Dubai | Elite Body Home",
                "description": "Professional IV drip therapy at home in Dubai with FREE consultation! Get hydration, vitamins and energy-boosting nutrients delivered to your doorstep. Book now.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-IV-Therapy.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "IV Drip Therapy"],
        "hero": {
            "title": "IV Drips at Home",
            "subtitle": "",
            "description": "Feeling fatigued and looking for a natural way to boost your energy and improve overall health? Enjoy the comfort of in-home IV vitamin therapy with Elite Body Home, one of Dubai's most popular health trends. IV therapy is the perfect solution for busy health-conscious individuals who prefer at-home care."
        },
        "howItWorks": {
            "title": "IV Drip Therapy Process",
            "description": "IV drip therapy delivers amino acids, antioxidants and essential nutrients directly to your cells for optimal performance. Whether you need an energy boost, deep hydration or concentrated vitamins, our professional service comes to you anywhere in Dubai."
        },
        "procedureSteps": {
            "heading": "",
            "para": "",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "Give us a call, one of our dedicated agents will assist you promptly.",
                    "icon": "fa-solid fa-phone"
                },
                {
                    "title": "Preparation",
                    "desc": "DHA certified nurse arrives at your home with all the necessary equipment.",
                    "icon": "fa-solid fa-kit-medical"
                },
                {
                    "title": "Administration",
                    "desc": "The IV drip is carefully inserted into your vein, and the nutrient-rich solution is infused over a 30–60-minute session.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Relax & Rejuvenate",
                    "desc": "You can relax in your own space while a professional ensures a smooth and monitored experience.",
                    "icon": "fa-solid fa-bed"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of IV Drip Infusion",
            "subheading": "",
            "para": "Opting for IV drip home service in Dubai brings several key health and convenience benefits, making it a top choice for busy professionals and those who value privacy.",
            "items": [
                {
                    "title": "Hydration Boost",
                    "desc": "Replenishes your body's hydration levels, ideal for post-exercise recovery or combating Dubai's hot climate.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "Energy Enhancement",
                    "desc": "Helps fight fatigue by delivering essential vitamins like B12 directly into your bloodstream.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Immune System Support",
                    "desc": "Strengthens your immunity with vitamin C, zinc, and other antioxidants, reducing the likelihood of illnesses.",
                    "icon": "fa-solid fa-shield-virus"
                },
                {
                    "title": "Customized Treatments",
                    "desc": "Formulas can be tailored to address your specific needs, such as anti-aging, stress relief, or improving mental clarity.",
                    "icon": "fa-solid fa-cogs"
                },
                {
                    "title": "Fast Recovery",
                    "desc": "Ideal for hangovers, jet lag, or illnesses, IV therapy delivers instant relief and quicker recovery.",
                    "icon": "fa-solid fa-medkit"
                },
                {
                    "title": "Ultimate Convenience",
                    "desc": "No need to travel, professionals come to your doorstep, saving time and effort.",
                    "icon": "fa-solid fa-truck"
                }
            ]
        },
        "eligibility": {
            "heading": "Ideal Candidate for IV Therapy",
            "subheading": "",
            "para": "IV therapy is beneficial for a wide range of individuals looking to improve their health and wellness:",
            "items": [
                {
                    "title": "Fatigue & Low Energy",
                    "desc": "Those feeling fatigued or low on energy.",
                    "icon": "fa-solid fa-battery-quarter"
                },
                {
                    "title": "Immune Support",
                    "desc": "Individuals needing immune system support.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "Hydration Needs",
                    "desc": "People seeking hydration or hangover recovery.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Athletes",
                    "desc": "Athletes needing faster recovery or muscle repair.",
                    "icon": "fa-solid fa-person-running"
                },
                {
                    "title": "Frequent Travelers",
                    "desc": "Those with jet lag from frequent travel.",
                    "icon": "fa-solid fa-plane"
                },
                {
                    "title": "Nutrient Deficiencies",
                    "desc": "Individuals with vitamin or nutrient deficiencies.",
                    "icon": "fa-solid fa-vitamins"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation Before IV Therapy",
            "subheading": "",
            "para": "Follow these simple steps to prepare for your IV drip session:",
            "items": [
                {
                    "title": "Stay Hydrated",
                    "desc": "Drink plenty of water before your session.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Eat Light",
                    "desc": "Have a light meal to avoid dizziness.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "Avoid Stimulants",
                    "desc": "Limit caffeine or alcohol before therapy.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Comfortable Clothing",
                    "desc": "Wear loose clothing for easy arm access.",
                    "icon": "fa-solid fa-shirt"
                }
            ]
        },
        "results": {
            "heading": "Expected Results",
            "subheading": "",
            "para": "After your IV drip therapy session, you can expect immediate and lasting benefits:",
            "items": [
                {
                    "title": "Immediate Hydration",
                    "desc": "Rapid rehydration at cellular level for instant refreshment.",
                    "icon": "fa-solid fa-droplet"
                },
                {
                    "title": "Energy Boost",
                    "desc": "Noticeable increase in energy levels within hours.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Improved Wellbeing",
                    "desc": "Enhanced overall feeling of health and vitality.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "Longer Lasting Effects",
                    "desc": "Nutrients continue working in your system for days.",
                    "icon": "fa-solid fa-clock"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Recommendations",
            "subheading": "",
            "para": "To maximize and maintain your IV therapy results:",
            "items": [
                {
                    "title": "Continue Hydrating",
                    "desc": "Drink plenty of water after your session.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Healthy Diet",
                    "desc": "Maintain a balanced diet rich in nutrients.",
                    "icon": "fa-solid fa-apple-whole"
                },
                {
                    "title": "Rest",
                    "desc": "Allow your body time to absorb the nutrients.",
                    "icon": "fa-solid fa-bed"
                },
                {
                    "title": "Follow-up Sessions",
                    "desc": "Schedule regular sessions for maintained benefits.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "Is IV drip therapy at home safe?",
                    "answer": "Yes, IV drip therapy at home is safe when performed by certified healthcare professionals. In Dubai, licensed nurses or doctors administer the treatment, ensuring proper sterilization and protocol adherence."
                },
                {
                    "question": "How long does an IV drip session last?",
                    "answer": "An IV drip session typically lasts between 30 to 60 minutes, depending on the type of infusion and your health needs."
                },
                {
                    "question": "What types of IV drips are available?",
                    "answer": "There are various formulations available, including hydration drips, immune-boosting drips, energy boosters, anti-aging drips, and drips tailored to alleviate jet lag, migraines, or hangovers."
                },
                {
                    "question": "How often can I get IV drip therapy?",
                    "answer": "The frequency of your sessions depends on your health goals and the recommendation of your healthcare provider. Some people opt for weekly sessions, while others may choose monthly treatments."
                },
                {
                    "question": "Can everyone use IV therapy?",
                    "answer": "IV therapy is safe for most people, but a healthcare provider will assess your eligibility based on your medical history and current health status. Those with certain medical conditions or allergies should consult with their doctor before starting IV therapy."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/iv-large.jpg",
            "beforeAfter": [

            ]
        },
        "product": {
            "id": 356,
            "title": "IV Drips at Home",
            "price": 599,
            "description": "Get hydration, vitamins, and energy-boosting nutrients delivered by professionals to your home—convenient wellness without clinic visits."
        }
    },
    "ar": {
        "url": "",
        "meta": {
            "title": "أفضل علاج التنقيط الوريدي في المنزل بدبي | ايليت بودي هوم",
            "description": "علاج تنقيط وريدي احترافي في المنزل بدبي مع استشارة مجانية! احصل على الترطيب والفيتامينات والعناصر الغذائية المعززة للطاقة مباشرة إلى منزلك. احجز الآن.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/ar/services/iv-drip-therapy-dubai/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "أفضل علاج التنقيط الوريدي في المنزل بدبي | ايليت بودي هوم",
                "description": "علاج تنقيط وريدي احترافي في المنزل بدبي مع استشارة مجانية! احصل على الترطيب والفيتامينات والعناصر الغذائية المعززة للطاقة مباشرة إلى منزلك. احجز الآن.",
                "url": "https://elitebodyhome.com/ar/services/iv-drip-therapy-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-01-22T13:54:57+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-IV-Therapy.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-IV-Therapy.jpg",
                "image_width": 1254,
                "image_height": 700,
                "image_alt": "علاج التنقيط الوريدي دبي",
                "image_type": "image/jpeg"
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "أفضل علاج التنقيط الوريدي في المنزل بدبي | ايليت بودي هوم",
                "description": "علاج تنقيط وريدي احترافي في المنزل بدبي مع استشارة مجانية! احصل على الترطيب والفيتامينات والعناصر الغذائية المعززة للطاقة مباشرة إلى منزلك. احجز الآن.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Elite-Body-Home-IV-Therapy.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "التنقيط الوريدي"],
        "hero": {
            "title": "التنقيط الوريدي في المنزل",
            "subtitle": "",
            "description": "هل تشعر بالإرهاق وتبحث عن طريقة طبيعية لتعزيز طاقتك وتحسين صحتك العامة؟ استمتع براحة العلاج داخل منزلك مع علاج التنقيط الوريدي بالفيتامينات من عيادات ايليت بودي هوم، حيث تُعرف كأبرز الاتجاهات الصحية التي تشهد إقبالًا واسعًا في دبي."
        },
        "howItWorks": {
            "title": "عملية التنقيط الوريدي",
            "description": "يوفر التنقيط الوريدي الأحماض الأمينية ومضادات الأكسدة والعناصر الغذائية الأساسية مباشرةً إلى خلايا الجسم لمساعدتها على الأداء بأفضل شكل. سواء كنت بحاجة إلى دفعة من الطاقة، أو ترطيب عميق، أو جرعة مركزة من الفيتامينات، خدمتنا تصل إليك أينما كنت في دبي."
        },
        "procedureSteps": {
            "heading": "",
            "para": "",
            "steps": [
                {
                    "title": "استشارة الطبيب",
                    "desc": "اتصل بنا، وسيقوم أحد ممثلينا المتخصصين بمساعدتك.",
                    "icon": "fa-solid fa-phone"
                },
                {
                    "title": "الاستعداد",
                    "desc": "تصل الممرضة المعتمدة من هيئة الصحة بدبي (DHA) إلى منزلك مجهزة بجميع الأدوات اللازمة.",
                    "icon": "fa-solid fa-kit-medical"
                },
                {
                    "title": "التنقيط الوريدي",
                    "desc": "يتم إدخال الإبرة بعناية في الوريد، ثم يُضخ المحلول الغني بالفيتامينات والمغذيات على مدار 30 إلى 60 دقيقة.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "الاسترخاء والتجدد",
                    "desc": "استمتع بالراحة في منزلك بينما يقوم المتخصص بمتابعة الجلسة لضمان تجربة سلسة وآمنة.",
                    "icon": "fa-solid fa-bed"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد التنقيط الوريدي",
            "subheading": "",
            "para": "يمنحك اختيارك لخدمة الحقن الوريدي في المنزل في دبي مزايا صحية وراحة استثنائية، مما يجعلها خيارًا مثاليًا للأشخاص المشغولين وكل من يقدر الخصوصية.",
            "items": [
                {
                    "title": "تعزيز ترطيب جسمك",
                    "desc": "يعيد العلاج توازن السوائل في الجسم، وهو مثالي بعد التمارين أو لمواجهة الحرارة المرتفعة في دبي.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "زيادة الطاقة",
                    "desc": "يقاوم الإرهاق من خلال تزويد الجسم بفيتامينات أساسية مثل فيتامين ب 12 مباشرةً عبر مجرى الدم.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "دعم الجهاز المناعي",
                    "desc": "يعزز المناعة بفضل احتوائه على فيتامين سي والزنك ومضادات الأكسدة، مما يقلل من فرص الإصابة بالأمراض.",
                    "icon": "fa-solid fa-shield-virus"
                },
                {
                    "title": "تركيبة مخصصة",
                    "desc": "يمكن تخصيص التركيبات لتلائم احتياجاتك الخاصة، سواء لمكافحة علامات التقدم في العمر أو تقليل التوتر أو تعزيز التركيز الذهني.",
                    "icon": "fa-solid fa-cogs"
                },
                {
                    "title": "تعافٍ سريع",
                    "desc": "يُعد علاج مثالي من آثار الإرهاق، أو السفر الطويل، أو بعض الأمراض، حيث يمنحك راحة فورية ويسرع عملية التعافي.",
                    "icon": "fa-solid fa-medkit"
                },
                {
                    "title": "راحة قصوى",
                    "desc": "لا حاجة للخروج من المنزل؛ لأن أطباؤنا المتخصصون يصلون إليك أينما كنت، مما يوفر الوقت والجهد.",
                    "icon": "fa-solid fa-truck"
                }
            ]
        },
        "eligibility": {
            "heading": "المرشح المثالي للعلاج بالتنقيط الوريدي",
            "subheading": "",
            "para": "يستفيد من العلاج بالتنقيط الوريدي مجموعة واسعة من الأشخاص الذين يسعون لتحسين صحتهم ورفاهيتهم:",
            "items": [
                {
                    "title": "الإرهاق ونقص الطاقة",
                    "desc": "الأشخاص الذين يعانون من الإرهاق أو نقص الطاقة.",
                    "icon": "fa-solid fa-battery-quarter"
                },
                {
                    "title": "دعم المناعة",
                    "desc": "الأشخاص الذين يحتاجون إلى دعم إضافي لجهاز المناعة.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "احتياجات الترطيب",
                    "desc": "الأشخاص الذين يبحثون عن الترطيب أو التعافي من الإرهاق بعد السهر.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "الرياضيون",
                    "desc": "الرياضيون الذين يسعون إلى تعافٍ أسرع وإصلاح العضلات.",
                    "icon": "fa-solid fa-person-running"
                },
                {
                    "title": "المسافرون الدائمون",
                    "desc": "من يعانون من اضطراب الرحلات الطويلة بسبب السفر المتكرر.",
                    "icon": "fa-solid fa-plane"
                },
                {
                    "title": "نقص العناصر الغذائية",
                    "desc": "الأشخاص الذين يعانون من نقص في الفيتامينات أو العناصر الأساسية.",
                    "icon": "fa-solid fa-vitamins"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد قبل جلسة التنقيط الوريدي",
            "subheading": "",
            "para": "اتبع هذه الخطوات البسيطة للاستعداد لجلسة التنقيط الوريدي:",
            "items": [
                {
                    "title": "حافظ على ترطيب جسمك",
                    "desc": "احرص على شرب كمية كافية من الماء قبل الجلسة.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "تناول وجبة خفيفة",
                    "desc": "تناول وجبة خفيفة لتفادي الشعور بالدوار.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "تجنب المنبهات",
                    "desc": "تجنب الكافيين أو المشروبات الكحولية قبل الجلسة.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "ملابس مريحة",
                    "desc": "ارتدِ ملابس مريحة تسمح بالوصول بسهولة إلى الذراع.",
                    "icon": "fa-solid fa-shirt"
                }
            ]
        },
        "results": {
            "heading": "النتائج المتوقعة",
            "subheading": "",
            "para": "بعد جلسة العلاج بالتنقيط الوريدي، يمكنك توقع فوائد فورية ودائمة:",
            "items": [
                {
                    "title": "ترطيب فوري",
                    "desc": "إعادة ترطيب سريع على المستوى الخلوي لانتعاش فوري.",
                    "icon": "fa-solid fa-droplet"
                },
                {
                    "title": "زيادة الطاقة",
                    "desc": "زيادة ملحوظة في مستويات الطاقة خلال ساعات.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "تحسن الصحة العامة",
                    "desc": "تحسن شامل في الشعور بالصحة والحيوية.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "نتائج طويلة الأمد",
                    "desc": "تستمر العناصر الغذائية في العمل في جسمك لأيام.",
                    "icon": "fa-solid fa-clock"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح ما بعد العلاج",
            "subheading": "",
            "para": "لتعظيم نتائج العلاج بالتنقيط الوريدي والمحافظة عليها:",
            "items": [
                {
                    "title": "استمر في الترطيب",
                    "desc": "اشرب الكثير من الماء بعد الجلسة.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "نظام غذائي صحي",
                    "desc": "حافظ على نظام غذائي متوازن غني بالعناصر الغذائية.",
                    "icon": "fa-solid fa-apple-whole"
                },
                {
                    "title": "الراحة",
                    "desc": "امنح جسمك الوقت الكافي لامتصاص العناصر الغذائية.",
                    "icon": "fa-solid fa-bed"
                },
                {
                    "title": "جلسات المتابعة",
                    "desc": "حدد جلسات منتظمة للحفاظ على الفوائد.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "هل العلاج بالتنقيط الوريدي في المنزل آمن؟",
                    "answer": "نعم، العلاج بالتنقيط الوريدي في المنزل آمن عند إجرائه بواسطة متخصصين طبيين معتمدين. في دبي، يتم إعطاء العلاج بواسطة ممرضين أو أطباء مرخصين مع الالتزام الكامل بإجراءات التعقيم والبروتوكولات الطبية."
                },
                {
                    "question": "كم تستغرق جلسة التنقيط الوريدي؟",
                    "answer": "تستغرق جلسة التنقيط الوريدي عادةً ما بين 30 إلى 60 دقيقة، حسب نوع المحلول المستخدم واحتياجاتك الصحية."
                },
                {
                    "question": "ما أنواع محاليل التنقيط الوريدي المتوفرة؟",
                    "answer": "هناك تركيبات متنوعة متاحة، تشمل محاليل الترطيب، محاليل تعزيز المناعة، محاليل زيادة الطاقة، محاليل مضادة للشيخوخة، ومحاليل مخصصة للتغلب على اضطراب الرحلات الجوية أو الصداع النصفي أو آثار الإفراط في الشرب."
                },
                {
                    "question": "كم مرة يمكنني الحصول على العلاج بالتنقيط الوريدي؟",
                    "answer": "يعتمد تكرار الجلسات على أهدافك الصحية وتوصيات الطبيب المعالج. بعض الأشخاص يختارون جلسات أسبوعية، بينما يفضل آخرون جلسات شهرية."
                },
                {
                    "question": "هل يمكن للجميع استخدام العلاج بالتنقيط الوريدي؟",
                    "answer": "العلاج بالتنقيط الوريدي آمن لمعظم الناس، ولكن سيتم تقييم أهليتك بناءً على تاريخك الطبي وحالتك الصحية الحالية. يجب على الأشخاص الذين يعانون من حالات طبية معينة أو حساسيات استشارة طبيبهم قبل البدء بالعلاج."
                }
            ]
        },
        "treatmentAreas1": [],
        "treatmentAreas2": []
    }
}